import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './Tag.module.scss';

const VARIANTS = {
  info: styles.info,
  warning: styles.warning,
  success: styles.success,
};

const Tag = ({
  className,
  textClassName,
  children,
  variant,
}: {
  className: any;
  textClassName: any;
  children: any;
  variant: any;
}) => (
  <div
    className={cn(
      styles.tag,
      idxMap(VARIANTS as Record<string, string>, variant),
      className,
    )}
  >
    <Typography
      className={cn(styles.text, textClassName)}
      variant="body3"
      mode="compact"
      weight="semiBold"
    >
      {children}
    </Typography>
  </div>
);

export default React.memo(Tag) as any;
